export const NEW_TASKS = 'NEW_TASKS';
export const NEW_TASK = 'NEW_TASK';
export const NEW_UPDATED_TASK = 'NEW_UPDATED_TASK';
export const REMOVE_TASK = 'REMOVE_TASK';
export const NEW_ACTIVE_TASK = 'NEW_ACTIVE_TASK';
